import React, { useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Box, Typography, CircularProgress, TextField } from "@mui/material";
import { apiVariable } from "../../../api/apiVariable";
import useAuth from "../../../hooks/useAuth";
import { lendersTableColumns } from "../../../data/FormColumns/Fleet/lendersTableColumns";
import PersistedDataGrid from "../../PersistedDataGrid/PersistedDataGrid";

const fetchLenders = async (token: string | undefined | null) => {
  const { data } = await axios.get(`${apiVariable}/getAllLenders`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

const LendersTable: React.FC = () => {
  const { token } = useAuth();

  const [searchTerm, setSearchTerm] = useState("");

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["lenders"],
    queryFn: () => fetchLenders(token),
    enabled: !!token,
  });

  const filteredLenders = useMemo(() => {
    if (!data) return [];
    return data.filter((sale: any) =>
      [sale.name, sale.phoneNumber].some((field) =>
        field?.toString().toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [data, searchTerm]);

  return (
    <Box className="incidents-table-container" height={900}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <TextField
          label="Search"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search Name or Phone Number"
          sx={{ maxWidth: "100%", width: 400 }}
        />
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : isError ? (
        <Typography color="error">Error: {(error as any).message}</Typography>
      ) : (
        <PersistedDataGrid
          tableName="lenders"
          rows={filteredLenders}
          columns={lendersTableColumns}
          sx={{ height: 700 }}
        />
      )}
    </Box>
  );
};

export default LendersTable;
